module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO46DeterminarPatrimonio.002746b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO46DeterminarPatrimonio.mp4
// module id = 772
// module chunks = 1